import React from 'react';

const Pagination = ({ numberOfDots, activePage }) => {
  return (
    <>
    <div style={{display:'flex'}}>
      {Array.from({ length: numberOfDots }, (_, index) => (
        <div
          key={index}
          style={{
            width: '10px',
            height: '10px',
            borderRadius: '50%',
            background: index + 1 === activePage ? '#0091D5' : '#7E909A',
          }}
        ></div>
      ))}  
    </div>
    <p style={{color:"#7E909A", marginTop:'-5px'}}>{activePage}/{numberOfDots}</p>
    
    </>
  );
};

export default Pagination;
